<template>
  <span :class="{'has-count': showCount}" class="rating-icon">
    <img
      :src="
        rating
          ? require('@/assets/images/icons/good.svg')
          : require('@/assets/images/icons/bad.svg')
      "
    />
    <strong v-if="showCount" class="rating-count">{{ count }}</strong>
  </span>
</template>
<style lang="scss" scoped>
.rating-icon {
  &.has-count {
    display: flex;
    align-items: center;

    .rating-count {
      margin-left: 7px;
    }
  }
}
</style>
<script>
export default {
  name: 'RatingIcon',
  props: {
    rating: {
      type: Boolean,
      default: true
    },
    count: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    showCount: function() {
      if (typeof this.count === 'number') return this.count.toString().length !== 0;

      return this.count.length !== 0;
    }
  }
};
</script>
